module.exports = __webpack_public_path__ + "img/horizontal_6_1_3009.9b27e98f.png";